import {IUITipoDePontuacaoLoja} from "./IUITipoDePontuacaoLoja";

export class IUITipoDePontuacaoQtdeFixaAtividade implements IUITipoDePontuacaoLoja {
  constructor(private empresa: any, private tipoDePontuacao: any, private tipoDeAcumulo: string, private atividade: any) {
  }

  calculePontos(valorVenda: number) {
    return this.atividade.pontosGanhos;
  }

  obtenhaPontosFormatado(valorVenda: number) {
    let pontos = this.calculePontos(valorVenda)

    if(this.tipoDeAcumulo === 'Reais')
      return    String(`R$ ${pontos.toFixed(2).replace('.', ',')}`)


    return String(`${pontos} ${pontos  <= 1 ? 'Selo' : "Selos" }`)
  }

}
